import "./Home.scss";
import HeroSection from "../../components/Banner/HeroSection";
// import { FormTop } from "../../components/FormTop/FormTop";
import ScrollToTop from "react-scroll-to-top";
import FeaturesGrid from "components/organisms/FeaturesGrid";
import ProcessSection from "components/organisms/ProcessSection";
import CtaBanner from "components/organisms/CtaBanner";
import FaqSection from "components/organisms/FaqSection";
import RepaymentTable from "components/organisms/RepaymentTable";
import FooterSection from "components/organisms/FooterSection";
import ResumeStepPopup from "../../components/ResumeStepPopup/ResumeStepPopup";

const Home = () => {

  return (
    <div
      className="wrapper"
      style={{
        overflowX: "hidden"
      }}
    >
      <ResumeStepPopup />
      <ScrollToTop smooth color="#278BA2" style={{zIndex: 999}} />
      <HeroSection />
      <FeaturesGrid />
      <ProcessSection />
      <CtaBanner />
      <FaqSection />
      <RepaymentTable />
      <FooterSection />
    </div>
  );
};

export default Home;
